/**
 * Created by Jonas Wålekvist on 2018-01-25.
 */

import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {DungeonQuestGameAssets} from "../DungeonQuestGameAssets";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameIntroView, IGameIntroViewConfig} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {DungeonQuestLogo} from "../backgrounds/parts/DungeonQuestLogo";
import {Linear, TweenLite} from "gsap";


export class DungeonQuestGameIntroView extends GameIntroView {

    private _featureContainer:PIXI.Container;
    private _logo:DungeonQuestLogo;
    public zoomFactor:number = 1.2;  //Used in gs animation
    private _animation:TweenLite;
    private _calculatedScale:number;

    constructor(config:IGameIntroViewConfig) {
        super(config);
    }

    protected createBackground():PIXI.DisplayObject {
        return new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.INTRO_BACKGROUND)[0]);
    }

    protected initAnimations():void {
        super.initAnimations();
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._featureContainer = new PIXI.Container();
        this._logo = new DungeonQuestLogo(new PIXI.Point(0.5, 0));


        this._featureContainer.addChild(this._logo);

        return this._featureContainer;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        if(resizeData.orientation == Orientation.LANDSCAPE) {
            this._logo.scale.set(this._orientationScale);
            this._logo.position.set(this._screenWidth * 0.5, this._screenHeight * 0.025);
        } else {
            this._logo.scale.set(this._orientationScale);
            this._logo.position.set(this._screenWidth * 0.5, this._screenHeight * 0.05);
        }
    }


    protected onResizeBackground(data:IResizeData):void {
        const widthScale = this._screenWidth / (<PIXI.Sprite>this._background).texture.width;
        const heightScale = this._screenHeight / (<PIXI.Sprite>this._background).texture.height;
        this._calculatedScale = Math.max(widthScale, heightScale);
        this.updateZoom();

        if(widthScale < heightScale) {
            //Portrait
            (<PIXI.Sprite>this._background).anchor.set(0.2, 0.5);
            (<PIXI.Sprite>this._background).position.set(this._screenWidth * (<PIXI.Sprite>this._background).anchor.x, this._screenHeight * (<PIXI.Sprite>this._background).anchor.y);
        } else {
            //Landscape
            (<PIXI.Sprite>this._background).anchor.set(0.2, 0.5);
            (<PIXI.Sprite>this._background).position.set(this._screenWidth * (<PIXI.Sprite>this._background).anchor.x, this._screenHeight * (<PIXI.Sprite>this._background).anchor.y);
        }

    }

    public updateZoom() {
        this._background.scale.set(this._calculatedScale * this.zoomFactor);
    }

    private startZoomAnimation(duration:number) {
        if(this._animation) {
            return;
        }
        this._animation = new TweenLite(this, duration, {
            zoomFactor : 1,
            onUpdate : () => this.updateZoom(),
            ease : Linear.easeNone
        });
    }


    enableButton():void {
        this.startAnimations();
        super.enableButton();
    }

    private startAnimations() {
        this.startZoomAnimation(25);
        this._logo.startLoop();
    }
}